import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    title: {
      display: 'block',
      maxWidth: 480,
      marginBottom: Spacings.s16,
      fontSize: FontSizes.s42,
      lineHeight: LineHeights.l50,

      [mediaQuery(1365)]: {
        maxWidth: 374,
        fontSize: FontSizes.s36,
        lineHeight: LineHeights.l48,
      },

      [mediaQuery(1023)]: {
        maxWidth: 312,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },
    gradient: {
      display: 'block',
      maxWidth: 480,
      marginBottom: Spacings.s16,
    },
    description: {
      display: 'block',
      maxWidth: 480,
      marginBottom: Spacings.s40,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l32,

      [mediaQuery(1365)]: {
        maxWidth: 374,
        marginBottom: Spacings.s24,
      },

      [mediaQuery(1023)]: {
        maxWidth: 312,
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l24,
      },
    },
    milestones: {
      marginBottom: Spacings.s40,
      [mediaQuery(1365)]: {
        marginBottom: Spacings.s24,
      },
    },
    priceBox: {
      marginBottom: Spacings.s8,
    },
    actionItemHolder: {
      display: 'flex',
      [mediaQuery(1023)]: {
        justifyContent: 'center',
      },
    },
    action: {
      '&&': {
        height: 'auto',
        marginTop: Spacings.s24,
        padding: [Spacings.s16, Spacings.s32],
        fontWeight: FontWeights.medium,
        fontSize: FontSizes.s20,
        lineHeight: LineHeights.l24,
      },
    },

    // SKELETON
    rootFallback: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      [mediaQuery(1023)]: {
        maxWidth: 330,
        overflowX: 'scroll',
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        minWidth: '100%',
      },
    },
    creativeBenefitsItemFallback: {
      width: 70,
      height: 100,
    },
    titleFallback: {
      height: 32,
      marginBottom: Spacings.s24,
    },
    actionFallback: {
      width: 300,
      height: 56,
    },
  }),
  {
    name: 'marketing-content',
  },
);

export default useStyles;
